import {
   ADD_NOTIFY_ME,
   DELETE_NOTIFY_ME,
   GET_NOTIFICATION,
   GET_NOTIFY_ME,
   UPDATE_NOTIFY_ME,
   UPDATE_NOTIFY_ME_STATUS,
} from '../types';

const initialState = { list: [], single: null };

const reducer = (state = initialState, action) => {
   const { type, payload } = action;

   switch (type) {
      case GET_NOTIFY_ME:
         return { ...state, list: payload };

      case ADD_NOTIFY_ME:
         return {
            ...state,
            list: [payload, ...state.list],
         };

      case UPDATE_NOTIFY_ME:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
         };

      case UPDATE_NOTIFY_ME_STATUS:
         return {
            ...state,
            list: state.list.map((user) => (user.id === payload.id ? { ...user, status: payload.status } : user)),
         };

      case DELETE_NOTIFY_ME:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
         };

      case GET_NOTIFICATION:
         return {
            ...state,
            Notification: payload.data || [],
            pagination: payload.pagination || {},
            totalCount: payload.totalCount || 0,
         };

      default:
         return state;
   }
};

export default reducer;
